import React from "react";
import { FaGreaterThan, FaLessThan, FaBan } from "react-icons/fa";

const Pagination = ({ currentPage, setCurrentPage, totalPages }) => {
  const isDataAvailable = totalPages > 0;

  return (
    <div className="page-main-report">
      <div className="page-section">
        <div className="pagination">
          <button
            className="greyButton"
            disabled={!isDataAvailable || currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            {isDataAvailable ? <FaLessThan /> : <FaBan />}
          </button>

          <span className="pagination-button">
            {isDataAvailable ? currentPage : "-"}
          </span>

          <button
            className="greyButton"
            disabled={!isDataAvailable || currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            {isDataAvailable ? <FaGreaterThan /> : <FaBan />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;